module.exports = __webpack_public_path__ + "img/9788997798070.5ecee383.jpg";